/* eslint-disable indent */
import 'rc-slider/assets/index.css';

import styled, { css } from 'react-emotion';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';

const RangeSliderContainer = withDirection(styled.div`
  width: 95%;
  padding: 5px;
  margin-left: 3px;
  ${cssMediaMax.tablet`
    width: 99% !important;
  `}
  overflow: unset;
  .rc-slider-handle {
    ${props => (props.direction === 'rtl'
      ? css`
        margin-left: -15px;
      `
      : css`
        margin-left: -7px;
      `
    )};
  }
`);

export default RangeSliderContainer;
